<template>
  <div class="table_head">
    <table>
      <colgroup>
        <col v-for="(th,index) in thead" :key="index" :width="th.width" />
      </colgroup>
      <thead>
        <tr>
          <th
            :class="[th.align=='center'?'text_center':'',is_class(th.name)]"
            v-for="(th,index) in thead"
            :key="index"
          >
            {{th.name}}
            <Sort v-if="sort" :name="name" :th="th" @tableSort="tableSort"></Sort>
          </th>
        </tr>
      </thead>
    </table>
  </div>
</template>
<style lang="scss">
.table_head {
  position: absolute;
  z-index: 1;
  width: 100%;
  overflow: hidden;
}
</style>
<script>
import Sort from "./Sort";
export default {
  name: "table-fixed-head",
  props: {
    thead: Array,
    name: String,
    sort: { type: Boolean, default: true },
    thead_scroll: Number,
  },
  components: {
    Sort,
  },
  computed: {
    is_class() {
      return function (name) {};
    },
  },
  methods: {
    tableSort(sortAttr) {
      this.$emit("tableSort", sortAttr);
    },
  },
  watch: {
    thead_scroll(newValue, oldValue) {
        this.$el.scrollLeft = newValue;
    },
  },
  mounted() {
    this.$nextTick(() => {
      //抓到自己的高度回傳
      this.$emit("eventGetHeight", this.$el.offsetHeight);
    });
  },
};
</script>